export default __webpack_public_path__ + "static/media/ic_menu.c244df3a.svg";